const sellerTypes = {
  // Financial companies / banks (Trusted, green)
  "mid-atlantic finance company": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "element fleet management": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "alamo financial group": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "hyundai capital – retail": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "gm financial": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "american credit acceptance": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "bridgecrest": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "exeter finance": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "united auto credit corporation": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "flagship credit impounds": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "westlake financial": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "jp morgan chase": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "titlemax loans": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "toyota financial": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "toyota financial services": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "toyota fleet financial": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "capital one": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "ally financial": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "american credit acceptance": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "td auto finance": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "us bank": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "navy federal credit union": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "veridian credit union": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },
  "world omni": {
    label: "Trusted",
    color: "#008000",
    category: "FinancialCompany",
  },

  // Fleet / lease companies (Trusted, green)
  holman: { label: "Trusted", color: "#008000", category: "FleetLeaseCompany" },
  "wheels inc": {
    label: "Trusted",
    color: "#008000",
    category: "FleetLeaseCompany",
  },
  "enterprise fleet management": {
    label: "Trusted",
    color: "#008000",
    category: "FleetLeaseCompany",
  },
  "element fleet management": {
    label: "Trusted",
    color: "#008000",
    category: "FleetLeaseCompany",
  },

  // Rental companies (Trusted, green)
  hertz: { label: "Trusted", color: "#008000", category: "RentalCompany" },
  enterprise: { label: "Trusted", color: "#008000", category: "RentalCompany" },
  avis: { label: "Trusted", color: "#008000", category: "RentalCompany" },
  sixt: { label: "Trusted", color: "#008000", category: "RentalCompany" },
  "fox rent a car": {
    label: "Trusted",
    color: "#008000",
    category: "RentalCompany",
  },
  "u-haul": { label: "Trusted", color: "#008000", category: "RentalCompany" },

  // Wholesale (Orange, conditional)
  "carbrain llc - ach": {
    label: "Wholesale",
    color: "#FF681F",
    category: "Wholesale",
  },
  wheelzy: {
    label: "Wholesale",
    color: "#FF681F",
    category: "Wholesale",
  },
  "advanced remarketing services - ach": {
    label: "Wholesale",
    color: "#FF681F",
    category: "Wholesale",
  },

  // Charities (Orange, conditional)
  "charitable adult rides & services": {
    label: "Charity",
    color: "#FF681F",
    category: "Charity",
  },
  "honorbound foundation": {
    label: "Charity",
    color: "#FF681F",
    category: "Charity",
  },
  "kars4kids lakewood pa": {
    label: "Charity",
    color: "#FF681F",
    category: "Charity",
  },
  "national kidney foundation utah ach": {
    label: "Charity",
    color: "#FF681F",
    category: "Charity",
  },
  "vehicles for charity": {
    label: "Charity",
    color: "#FF681F",
    category: "Charity",
  },

  // Dealers (Orange, conditional → Non-Insurance)
  autonation: {
    label: "Non-Insurance",
    color: "#FF681F",
    category: "Dealer",
  },
  "carmax business": {
    label: "Non-Insurance",
    color: "#FF681F",
    category: "Dealer",
  },
  carvana: {
    label: "Non-Insurance",
    color: "#FF681F",
    category: "Dealer",
  },
  drivetime: {
    label: "Non-Insurance",
    color: "#FF681F",
    category: "Dealer",
  },

  // Insurance (Trusted, green)
  "florida farm bureau group": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "ocean harbor insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  progressive: {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  geico: {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "granada insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "infinity insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "assurance america insurance company": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "erie insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "state farm insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "arbella insurance company": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "mapfre usa": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "hanover insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "farm bureau insurance group": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "equity insurance company": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "trexis insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "farmers insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "inspection services - donegal insurance group": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "atlantic states insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "penn national insurance group": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "philadelphia insurance companies": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "pilgrim insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "plymouth rock assurance corp": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "travelers insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "aaa insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "aaa ohio": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "aaa rhode island": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  "bristol west insurance": {
    label: "Insurance",
    color: "#008000",
    category: "Insurance",
  },
  usaa: { label: "Insurance", color: "#008000", category: "Insurance" },
};

export { sellerTypes };
